module.exports = __webpack_public_path__ + "img/Noam-Syrkin.59aa1183.png";